/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteGlobalRemoteSessionClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteGlobalRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteGlobalRemoteSessionClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGlobalRemoteSessionClientSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteGlobalRemoteSessionClientSecurity$Outbound,
    DeleteGlobalRemoteSessionClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteGlobalRemoteSessionClientSecurityToJSON(
  deleteGlobalRemoteSessionClientSecurity:
    DeleteGlobalRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    DeleteGlobalRemoteSessionClientSecurity$outboundSchema.parse(
      deleteGlobalRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type DeleteGlobalRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteGlobalRemoteSessionClientRequest$outboundSchema:
  z.ZodMiniType<
    DeleteGlobalRemoteSessionClientRequest$Outbound,
    DeleteGlobalRemoteSessionClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteGlobalRemoteSessionClientRequestToJSON(
  deleteGlobalRemoteSessionClientRequest:
    DeleteGlobalRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    DeleteGlobalRemoteSessionClientRequest$outboundSchema.parse(
      deleteGlobalRemoteSessionClientRequest,
    ),
  );
}
